const resources = {
    seeMore: 'See more reviews that mention',
    linkLead: 'Highly rated by customers for:',
    linkLeadRedesign: 'Highly rated for:',
    modalTitle: 'Highly Rated by Customers for'
};

export default function getResource(label) {
    return resources[label];
}
